export const saveFlightData = flightData => ({
    type: "SAVE_FLIGHT_DATA",
    flightData,
});

export const saveIntFlightData = intFlightData => ({
    type: "SAVE_INT_FLIGHT_DATA",
    intFlightData,
});

export const saveTicketSort = ticketSort => ({
    type: "SAVE_TICKET_SORT",
    ticketSort,
});

export const saveTicketSelectedFilters = ticketSelectedFilters => ({
    type: "SAVE_TICKET_SELECTED_FILTERS",
    ticketSelectedFilters,
});

export const saveHotelData = hotelData => ({
    type: "SAVE_HOTEL_DATA",
    hotelData,
});

export const saveHotelSort = hotelSort => ({
    type: "SAVE_HOTEL_SORT",
    hotelSort,
});

export const saveHotelSelectedFilters = hotelSelectedFilters => ({
    type: "SAVE_HOTEL_SELECTED_FILTERS",
    hotelSelectedFilters,
});

export const saveItineraryList = itineraryList => ({
    type: "SAVE_ITINERARY_LIST",
    itineraryList,
});

export const saveTourList = tourList => ({
    type: "SAVE_TOUR_LIST",
    tourList,
});

export const resetState = () => ({
    type: "RESET_STATE",
});

export const saveSelectedTicket = selectedTicket => ({
    type: "SAVE_SELECTED_TICKET",
    selectedTicket,
});
